export async function fetchAsasToken(): Promise<string> {
  const response = await fetch(
    `${process.env.API_ASAS_GARANTIA_URL}/services/garantia-security-api/oauth/token`,
    {
      method: 'POST',
      headers: {
        Authorization: 'Basic Z2FyYW50aWFzLXdlYi1hcHA6MXEydzNlNHIjZ2FyYW50aWFz',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'password',
        username: 'integracao.bbmnet@asasinsurance.com',
        password: '{G5QL!(Avsrf',
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`Falha ao autenticar na API ASAS (${response.status})`);
  }

  const { access_token } = await response.json();

  if (!access_token) {
    throw new Error('Token ASAS não retornado pela API');
  }

  return access_token;
}
